/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.animationModule')
.animation('.bulb-slide', ['$log', function($log) {

  function grabContentHeight(element) {
    // Temporarily remove display:none and add visibility:hidden to grab element's browser-computed height
    var display = element.css('display');
    var visibility = element.css('visibility');
    var contentHeight = element.css({
        'display': 'inherit',
        'visibility': 'hidden'
      })[0].offsetHeight + 'px';
    // Restore element's display and visibility to their previous values
    element.css({
      'display': display,
      'visibility': visibility
    });
    return contentHeight;
  }

  return {
    addClass: function(element, className, done) {
      var contentHeight = grabContentHeight(element.find('.bulb-active-content'));
      $log.debug('.bulb-slide animating to height ' + contentHeight);
      element.animate({
        height: contentHeight
      }, done);
    },
    removeClass: function(element, className, done) {
      $log.debug('.bulb-slide animating to height 0');
      element.animate({
        height: 0
      }, function() {
        done();
      });
    }
  };
}]);
